import React, { useCallback, useEffect, useState } from "react";

import styled from "styled-components/macro";

import INTERVAL from "Payments/Shared/intervalEnum";
import { AnimatePresence, motion } from "framer-motion";
import { DateTime } from "luxon";

import API from "../../../API";
import { useRecurringGifts } from "../../../RecurringGiftsContext";
import { useSubtotal } from "../stateHooks";


export default function TotalAmount() {
  const { state } = useRecurringGifts();
  const { startDate, endDate, amountInDollars, interval } =
    state.editModal.giftWithEdits;
  const subTotal = useSubtotal();
  const { paymentType } = state.editModal.currentGift;
  const [totalAmount, setTotalAmount] = useState(null);

  const getTotalToGive = useCallback(async () => {
    if (!endDate || !subTotal || Number(subTotal) <= 0) {
      setTotalAmount(null);
      return;
    }

    let startD = DateTime.fromISO(startDate);
    let endD = DateTime.fromISO(endDate);

    const data = {
      startDate: startD.toMillis() / 1000,
      endDate: endD.toMillis() / 1000,
      intervalID: INTERVAL[interval.toUpperCase()].ID,
      amount: subTotal * 100,
    };

    const req = API.getTotalAmount(data);

    req
      .post()
      .then((res) => setTotalAmount(res.totalAmount))
      .catch(() => setTotalAmount(null));
  }, [subTotal, startDate, endDate, interval]);

  useEffect(
    function updateTotalToGive() {
      const run = async () => await getTotalToGive();
      run();
    },
    [getTotalToGive]
  );

  const trimmedTotal = (total) => {
    const isWholeNumber = total.split(".")[1] === "00";

    if (isWholeNumber) return total.split(".")[0];

    return total;
  };

  return (
    <AnimatePresence>
      {totalAmount && amountInDollars && endDate ? (
        <Wrapper
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
        >
          <IconWrapper>
            <Icon className="fa-money-bill-wave fad" />
          </IconWrapper>
          <Text>
            Remaining {paymentType}s:{" "}
            <Total data-cy="recurringRemainingTotal">
              {trimmedTotal(totalAmount)}
            </Total>
          </Text>
        </Wrapper>
      ) : null}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  overflow: hidden;

  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 60px;
  min-width: 60px;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

const Text = styled.div`
  font-weight: 400;
`;

const Total = styled.span`
  font-weight: 600;
`;